import classNames from 'classnames'
import React, { FunctionComponent } from 'react'
import { Icon } from '../../../shared'
import { getV3ColorCssVariable } from '../../../../design-system/colors_v3'
import { PatientInformationsContainerProps } from './PatientInformationsContainer.model'
import styles from './PatientInformationsContainer.module.scss'

export const PatientInformationsContainer: FunctionComponent<PatientInformationsContainerProps> = ({
  children,
  isIndicationGroup,
  cim10,
  onClick,
  testId,
}) => (
  <div
    onClick={onClick}
    className={classNames(styles.patientInformations, { [styles.pointer]: !!onClick })}
    data-test-id={testId}
  >
    <div className={styles.patientInformationsLabelWithCim10}>
      {children}
      {cim10 && <div className={styles.patientInformationsCim10}>{cim10}</div>}
    </div>
    {isIndicationGroup && (
      <Icon
        icon="caret"
        rotate={90}
        size="femto"
        color={getV3ColorCssVariable('shades', 'shade4')}
      />
    )}
  </div>
)
